import { Flags } from './types';

export function isTrace(flag: Flags | null | undefined): boolean {
  return flag === Flags.TRACES;
}

export function isUnclear(flag: Flags | null | undefined): boolean {
  return flag === Flags.UNCLEAR;
}

export function isUnquantified(flag: Flags | null | undefined): boolean {
  return flag === Flags.UNQUANTIFIED;
}

export function isNonQuantifiedFlag(flag: Flags | null | undefined): boolean {
  return isTrace(flag) || isUnclear(flag) || isUnquantified(flag);
}
